<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b>Request for medical Certificate :</b>
      </div> -->
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b>Request medical Certificate :</b>
        <b-button style="text-align: right" variant="danger" @click="handleBack"
          >Back</b-button
        > -->

      <div
        style="
          text-align: left;
          margin: 20px;
          margin-left: 10px;
          margin-right: 0px;
        "
        class=""
      >
        <h5>
          Medical Certificate
          <b-button class="float-right" @click="handleback" variant="danger">
            <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
          </b-button>
        </h5>
        <hr />
      </div>
      <div class="panel-body">
        <div>
          <div class="md-4">
            <b-card class="mb-3" style="height: 160px">
              <b-card-text class="mycard" @click="viewHandle1">
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Date
                  </div>
                  <div class="col-4">12-04-2020</div>
                  <div class="col-2">
                    <!-- <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft
                      text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        <b-icon-three-dots-vertical></b-icon-three-dots-vertical
                        ><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle"
                        >View</b-dropdown-item
                      >
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown> -->
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Tag No
                  </div>
                  <div class="col-4">44</div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Owner Name
                  </div>
                  <div class="col-6">Rajesh Sharma</div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    City
                  </div>
                  <div class="col-4">Solapur</div>
                  <div class="col-2"></div>
                </div>
                <br />
              </b-card-text>
            </b-card>
          </div>
          <div class="col-12" style="margin-top: 10px">
            <h5>Other Appointment
                <b-btn
          class="btn-success float-right"
          style="text-align: right"
          @click="requestHandle()"
        >
          New Request </b-btn>
            </h5>
          </div>
          <hr />
           <div class="md-4">
            <b-card class="mb-3" style="height: 160px">
              <b-card-text class="mycard">
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Date
                  </div>
                  <div class="col-4">12-04-2020</div>
                  <div class="col-2">
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft
                      text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template #button-content>
                        <b-icon-three-dots-vertical></b-icon-three-dots-vertical
                        ><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle"
                        >View</b-dropdown-item
                      >
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Tag No
                  </div>
                  <div class="col-4">44</div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    Owner Name
                  </div>
                  <div class="col-6">Rajesh Sharma</div>
                </div>
                <div class="row">
                  <div
                    class="col-6"
                    style="
                      font-size: 18px;
                      font-family: Arial;
                      font-weight: bold;
                    "
                  >
                    City
                  </div>
                  <div class="col-4">Solapur</div>
                  <div class="col-2"></div>
                </div>
                <br />
              </b-card-text>
            </b-card>
          </div>
         <div>
    <b-modal id="modal-1" ref="add-modal" title="Add Animal" hide-footer="true" ok-variant="hidden" cancel-variant="hidden">
        <b-form @submit.stop.prevent>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Tag No</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-input-group >
                        <template #append>
                            <b-input-group-text @click="handleSearch">
                                <b-icon-search></b-icon-search>
                            </b-input-group-text>
                        </template>
                        <b-form-input v-model="tag"></b-form-input>      
                    </b-input-group>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Type</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="type" placeholder=""></b-form-input>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Breed</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="breed" placeholder=""></b-form-input>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Is Calf Available ?</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="calf" placeholder=""></b-form-input>
                </div>
            </div>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Age</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="age" placeholder=""></b-form-input>
                </div>
            </div>
            <div class="col-md-12">
                <center>
                    <b-button v-b-modal.modal-sm variant="primary">View Medical Certificate</b-button>
                </center>
            </div>
            <b-modal id="modal-sm" size="sm" title="Medical Certificate">Medical Certificate Will go Here...</b-modal>
            <hr/>
            <div class="col-md-12">
                <center>
                    <b-button variant="success" @click="handleAdd">Add</b-button>
                </center>
            </div>
        </b-form> 
    </b-modal>
    </div>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    requestHandle(){
      this.$refs['add-modal'].show();
    },
    viewHandle() {
      this.$router.push("/home/medical");
    },
    handleback() {
      this.$router.go(-1);
    },
    viewHandle1(){
      this.$router.push('/home/viewmedical_certificate');
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
.btn {
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}

body {
  line-height: 1;
}
</style>
